<template>
  <div>
    <div class="data-point-list">
      <h1 class="signed-in-title heading">Nourish Data Point Manager</h1>
      <div class="toolbar">
        <a-input-search placeholder="Search" style="width: 200px" v-model="searchText" />
        <a-button type="primary" class="new-button" @click="showModal('')">
          Add New
        </a-button>
      </div>
      <div v-if="loading">
        <a-skeleton v-for="i in 3" :key="i" active />
      </div>
      <a-list v-if="!loading" size="small" bordered :data-source="filteredDataPoints">
        <a-list-item slot="renderItem" slot-scope="item">
          <a-list-item-meta :description="item.description">
            <a slot="title">{{ item.codename }}</a>
          </a-list-item-meta>
          <div class="data-point-actions">
            <a-button type="default" class="data-point-action" icon="edit" @click="showModal(item.codename, item.description)"/>
            <a-popconfirm
              title="Really delete this datapoint?"
              @confirm="deleteCodenameItem(item.codename)"
              okText="Yes"
              cancelText="No"
              >
              <a-button type="danger" class="data-point-action" icon="delete" />
            </a-popconfirm>
          </div>
        </a-list-item>
        <div slot="header">
          Data Point Codenames ({{ filteredDataPoints.length }})
        </div>
      </a-list>
    </div>

    <!-- New/Edit Data Point Modal -->
    <a-modal id="new-data-point-modal" v-model="visible" :title="[editing ? 'Edit Data Point' : 'New Data Point']" @ok="onSubmit" @cancel="onCancel">
      <a-form-model
        ref="ruleForm"
        :model="dataPoint"
        :rules="rules"
      >
      <a-form-model-item ref="codename" label="Name" prop="codename">
        <a-input
          v-model="dataPoint.codename" :disabled="editing ? true : false"
        />
      </a-form-model-item>
      <a-form-model-item ref="description" label="Description" prop="description">
        <a-input
          v-model="dataPoint.description"
        />
      </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { API } from 'aws-amplify'

export default {
  props: ['dataPoints', 'loading'],
  data: () => ({
    dataPoint: {
      codename: '',
      description: ''
    },
    current: 1,
    searchText: '',
    index: '',
    visible: false,
    editing: false,
    search: "",
    rules: {
        codename: [
          { required: true, message: 'Please input data point codename', trigger: 'blur' },
          { min: 1, max: 50, message: 'Length should be 1 to 50', trigger: 'blur' },
        ],
        description: [
          { required: true, message: 'Please input data point description', trigger: 'blur' },
          { min: 1, max: 50, message: 'Length should be 1 to 200', trigger: 'blur' },
        ]
    }
  }),
  computed: {
    filteredDataPoints() {
      let a
      if (this.searchText === '') {
        a = this.dataPoints
      } else {
        a = this.dataPoints.filter((dataPoint) => {
          if (dataPoint['codename'].includes(this.searchText)) {
            return true
          }
        })
      }
      return a.sort((a, b) => a.codename.localeCompare(b.codename))
    }
  },
  methods: {
    showModal(codename, description) {
      this.visible = true;
      if (codename !== '') {
        this.editing = true;
        this.dataPoint.codename = codename;
        this.dataPoint.description = description;
      }
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {

          if (this.dataPoints.some(item => item.codename === this.dataPoint.codename) && this.editing == false) {
            this.$message.error('Datapoint already exists!');
            return;
          }

          this.createCodenameItem(this.dataPoint);
          this.dataPoint = {};
          this.visible = false;

        } else {
          return;
        }
      });
    },
    onCancel() {
      this.editing = false;
      this.dataPoint = {};
    },
    onSearch(text) {
      this.searchText = text
    },
    async createCodenameItem(codenameItem) {
      const body = {
        codename: codenameItem.codename,
        description: codenameItem.description
      }
      const response = await API.post('dataPointManagerAPI', '/codenames/', { body })
      if ('__type' in response) {
        this.$message.error('Failed to save ' + codenameItem.codename)
        return false
      } else {
        this.$message.success('Saved ' + codenameItem.codename)
        this.$emit('itemAdded')
        return true
      }
    },
    async deleteCodenameItem(codename) {
      console.log(encodeURIComponent(codename));
      const response = await (API.del('dataPointManagerAPI', '/codenames/' + encodeURIComponent(codename).replace('!', '%21')))
      console.log('resp', response)
      if ('data' in response) {
        this.$message.success('Deleted ' + codename)
        this.$emit('itemDeleted')
        return true
      } else {
        this.$message.error('Failed to delete ' + codename)
        return false
      }
    }
  }
}
</script>

<style scoped>
  .data-point-list {
    margin: 0 auto;
    width: 800px;
    display: flex;
    flex-direction: column;
  }

  .data-point-actions {
    display: flex;
    justify-content: flex-end;
  }

  .data-point-action {
    margin: 0px 0px 0px 16px;
  }

  .toolbar {
    display: flex;
    justify-content: flex-end;
    margin: 10px 0px 16px 0px;
  }

  .new-button {
    margin-right: 0;
    margin-left: 16px;
  }

  .heading {
    text-align: center;
    margin-bottom: 40px;
  }
</style>